/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeItem/CollapsibleState` instead. */
export enum CollapsibleState {
  None = "none",
  Collapsed = "collapsed",
  Expanded = "expanded",
  Full = "full",
}
